import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import Process from './nplatform/Process';
import Curriculum from './nplatform/Curriculum';
import PageTop from '../components/pageTop/PageTop';
import { useNavigate } from 'react-router-dom';
import { copyUrl } from '../../utils/url';
import Question from '../promotion/components/seminar/Question';

const IMGBASE = '/assets/images/seminar/nplatform';

const difficultyData = [
  {
    title: '정보 비대칭',
    desc: '채권 정보가 파편화되어 있고, 실거래가·낙찰률 데이터 접근이 제한적입니다. 투자 판단에 필요한 핵심 정보를 얻기까지 과도한 시간과 비용이 소요됩니다.',
  },
  {
    title: '문서 처리의 복잡성',
    desc: '등기부등본, 건축물대장 등 법적 서류의 수작업 분석은 실수와 누락의 위험이 높습니다. 전문가 의존도가 높아 진입장벽이 존재합니다.',
  },
  {
    title: '느린 거래 프로세스',
    desc: '오프라인 중심의 거래 구조로 매물 발굴부터 계약까지 수주가 소요됩니다. 중개 비용도 높아 실질 수익률이 저하됩니다.',
  },
  {
    title: '리스크 평가의 어려움',
    desc: '채무자 상태, 담보물 가치, 법적 선순위 분석 등 복합적 리스크를 정량화하기 어렵습니다. 경험 기반 판단에 의존하는 실정입니다.',
  },
];

const valueData = [
  {
    title: 'AI 기반 완전 자동화',
    desc: 'OCR과 대규모 언어모델(LLM)을 결합해\n문서를 자동으로 읽고 분석합니다.',
    check: [
      'HWP, PDF, 이미지 등 모든 형식 지원',
      '등기부등본 자동 구조화 및 권리 분석',
      '건축물대장 자동 파싱 및 현황 정리',
      'AI Agent가 투자자별 최적 매물 추천',
    ],
  },
  {
    title: '실거래 데이터 기반 예측',
    desc: '축적된 실거래 DB를 기반으로 낙찰가, 낙찰률, 회수율을\n실시간 예측합니다.',
    check: [
      '지역별·물건 유형별 통계 분석',
      'AI 기반 낙찰가 시뮬레이션',
      '리스크 분석',
      '시장 트렌드 및 인사이트 리포트',
    ],
  },
  {
    title: '투명하고 효율적인 거래',
    desc: '매각자와 투자자를 직접 연결하여 거래를 투명하게 관리합니다.',
    check: [
      '매입자, 매각자, 투자자의 물건 정보 제공',
      '자동화된 계약서 및 리포트 생성',
    ],
  },
  {
    title: '매각 자문 & EXIT 마케팅',
    desc: '트랜스파머 × 바른NPL × 땅집고의 강력한 삼각 파트너십!\n안전한 자문・중개부터 국내 최대 부동산 언론!\nEXIT 마케팅까지 원스톱!',
    check: [],
  },
];

const competitionData = [
  {
    number: '01',
    title: 'OCR + LLM 완전 자동화',
    desc: '복잡한 법률 문서를\n단 몇 초 안에 정제된 데이터로 전환\n수작업 대비 오류율90% 이상 감소',
  },
  {
    number: '02',
    title: 'AI Agent 추천 시스템',
    desc: '투자자의 최적의 NPL을 찾아주고,\nNDA부터 입찰까지 원클릭으로 진행',
  },
  {
    number: '03',
    title: '실시간 시장 분석',
    desc: '낙찰률, 낙찰가율, 지역별 시세 등을 실시간으로 업데이트하여 투자 의사결정을 지원',
  },
];

const questionsData = [
  {
    idx: '01',
    title: '엔플랫폼은 어떤 서비스인가요?',
    answser:
      '엔플랫폼은 인공지능을 활용해 업무 효율을 높이고, 쉽고 빠르게 NPL 정보를 제공하는 올인원 AI 플랫폼입니다.',
  },
  {
    idx: '02',
    title: '별도의 설치가 필요한가요?',
    answser:
      '아니요, 웹 기반 플랫폼으로 별도 설치 없이 바로 이용하실 수 있습니다.',
  },
  {
    idx: '03',
    title: '기업용으로도 사용 가능한가요?',
    answser:
      '가능합니다. 기업 맞춤형 기능과 보안 환경을 협의 후 사용 가능합니다.',
  },
  {
    idx: '04',
    title: '기술 지원은 어떻게 받나요?',
    answser: '고객센터 또는 1:1 문의를 통해 신속히 지원해 드립니다.',
  },
  {
    idx: '05',
    title: '사업설명회는 무료 참석이 가능한가요?',
    answser: '네. 사업설명회는 앞으로도 무료로 정기적으로 진행 예정입니다.',
  },
];

function Nplatform() {
  const handleConfirmButton = () => {
    // if (!isLogin()) {
    //   modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
    //   return;
    // }
    // window.open('https://naver.me/xE6G9Rqw', '_blank');
  };

  const navigate = useNavigate();

  return (
    <Component>
      <Container>
        <PageTop />

        <BottomFloating>
          <FloatingContent>
            <FloatingIcon
              src="/assets/images/icon/blink-star.png"
              alt="blink"
            />
            <FloatingText>참가 신청 고객 100% 무료!</FloatingText>
          </FloatingContent>
          <FloatingButton onClick={handleConfirmButton}>
            마감되었습니다.
          </FloatingButton>
        </BottomFloating>

        <Keyvisual>
          <Header>
            <img
              src="/assets/images/logo/zipgoai_logo_mobile_footer2.svg"
              alt=""
              width={45}
              height={24}
              onClick={() => navigate('/')}
            />
            <HeaderIconButton
              onClick={() => copyUrl('https://zipgoai.com/seminar2509')}
            >
              <img src="/assets/images/icon/share-white.svg" alt="" />
            </HeaderIconButton>
          </Header>
          <MainImg src={`${IMGBASE}/main.png`} alt="" />
        </Keyvisual>

        <Section $padding={60} $bg="#000" $gap={40}>
          <SectionTitleContainer>
            <SectionTitle $color="#FFFFFF">
              왜 지금
              <br />
              NPL 거래 혁신이 필요한가?
            </SectionTitle>
            <SectionTitleDesc $color="#FFFFFF">
              국내 NPL 시장은 연간 수조원 규모이지만,
              <br />
              구조적 비효율로 인해 잠재적 투자자와
              <br />
              매각자 모두 어려움을 겪고 있습니다.
            </SectionTitleDesc>
          </SectionTitleContainer>
          <CardContainer>
            {difficultyData.map((item) => (
              <DifficultyCard key={item.title}>
                <DifficultyCardTitle>{item.title}</DifficultyCardTitle>
                <DifficultyCardDesc>{item.desc}</DifficultyCardDesc>
              </DifficultyCard>
            ))}
          </CardContainer>
        </Section>

        <Section $padding={0} $paddingBottom={40} $bg="#000" $gap={20}>
          <SectionTitle $color="#28FEFF" $weight={500}>
            엔플랫폼은 <br />이 모든 문제를 해결합니다!
          </SectionTitle>
          <SectionTitleDesc $color="#FFFFFF">
            AI 자동화・데이터 표준화
            <br />
            투명한 거래 구조・실시간 시장 분석
          </SectionTitleDesc>
        </Section>

        <Section $bg="#E3F7F7" $padding={0}>
          <CurveImg src={`${IMGBASE}/section-divider-curve.png`} alt="" />
        </Section>

        <Section $bg="#E3F7F7" $padding={40} $paddingBottom={60} $gap={40}>
          <SectionTitleContainer>
            <ValueTitleWrapper>
              <img src={`${IMGBASE}/laurel-left.svg`} alt="" />
              <SectionTitle $color="#121212">
                엔플랫폼이 제공하는
                <br />
                핵심 가치
              </SectionTitle>
              <img src={`${IMGBASE}/laurel-right.svg`} alt="" />
            </ValueTitleWrapper>
            <SectionTitleDesc $color="#121212">
              단순한 플랫폼이 아닌, NPL 거래 생태계 전체를
              <br />
              혁신하는 통합 솔루션입니다.
            </SectionTitleDesc>
          </SectionTitleContainer>
          <CardContainer>
            {valueData.map((item) => (
              <ValueCard key={item.title}>
                <ValueCardTitle>{item.title}</ValueCardTitle>
                <ValueCardDesc>{item.desc}</ValueCardDesc>
                <ValueCardCheckSection>
                  {item.check.map((c, idx) => (
                    <ValueCardCheckItem key={idx}>
                      <img
                        src="/assets/images/check/check-skyblue.svg"
                        alt=""
                      />
                      {c}
                    </ValueCardCheckItem>
                  ))}
                </ValueCardCheckSection>
              </ValueCard>
            ))}
          </CardContainer>
        </Section>

        <Section $bg="#FFF" $padding={60} $gap={40}>
          <SectionTitleContainer>
            <CompetitionTitleContainer>
              <SectionTitle $color="#121212">엔플랫폼의</SectionTitle>
              <SectionTitle $color="#1FCECF"> 기술 경쟁력</SectionTitle>
            </CompetitionTitleContainer>
            <SectionTitleDesc $color="#121212">
              최신 AI 기술과 금융 도메인 전문성의 결합으로
              <br />타 플랫폼과 차별화된 경쟁력을 확보했습니다.
            </SectionTitleDesc>
          </SectionTitleContainer>
          <CardContainer>
            {competitionData.map((item, idx) => (
              <CompetitionCard key={item.number}>
                <CompetitionCardHeader>
                  <CompetitionCardNumber>{item.number}</CompetitionCardNumber>
                  <CompetitionCardTitle>{item.title}</CompetitionCardTitle>
                </CompetitionCardHeader>
                <CompetitionCardDesc>{item.desc}</CompetitionCardDesc>
                <CompetitionCardImgContainer>
                  <CompetitionCardImg
                    src={`${IMGBASE}/competition${idx + 1}.png`}
                  />
                </CompetitionCardImgContainer>
              </CompetitionCard>
            ))}
          </CardContainer>
        </Section>

        <Section $bg="#282828" $padding={60} $gap={40}>
          <SectionTitleContainer>
            <ProcessSectionDesc>거래 프로세스</ProcessSectionDesc>
            <ProcessSectionTitle>
              투명하고 신뢰할 수 있는
              <br />
              5단계 프로세스
            </ProcessSectionTitle>
          </SectionTitleContainer>
          <Process />
        </Section>

        <Section $bg="#010E0F" $padding={60} $gap={40}>
          <SectionTitleContainer>
            <SectionTitle $color="#FFF">행사 커리큘럼</SectionTitle>
            <LocationInfo>
              <InfoRow>
                <img src="/assets/images/icon/calendar-white.svg" alt="" />
                25년 10월 30일 (목) 14:00 ~ 16:00
              </InfoRow>
              <InfoRow>
                <img src="/assets/images/icon/location-white.svg" alt="" />
                서울스퀘어 4F 상연재 (서울역 9번 출구)
              </InfoRow>
            </LocationInfo>
          </SectionTitleContainer>
          <Curriculum />
        </Section>

        <Section $bg="#05C7C8" $padding={0}>
          <CurveImg src={`${IMGBASE}/section-divider-curve2.png`} alt="" />
        </Section>

        <Section $bg="#05C7C8" $padding={40} $paddingBottom={60} $gap={40}>
          <SectionTitleContainer>
            <SectionTitle $color="#FFF">
              “NPL 시장의
              <br />
              미래를 가장 먼저 경험하세요”
            </SectionTitle>
            <SectionTitleDesc $color="#F2FFFF">
              AI 자동화부터 실시간 데이터 분석까지,
              <br />
              엔플랫폼의 모든 것을 2시간 안에 확인할 수 있습니다!
            </SectionTitleDesc>
          </SectionTitleContainer>
          <ApplicationWrapper>
            <Bubble>
              <BubbleMessage>참가비 100% 무료!</BubbleMessage>
              <BubbleTail />
            </Bubble>
            <ApplicationButton onClick={handleConfirmButton}>
              마감되었습니다.
            </ApplicationButton>
          </ApplicationWrapper>
        </Section>

        <Section $bg="#FFF" $padding={60} $gap={40}>
          <SectionTitleContainer>
            <SectionTitle $color="#121212">오시는길</SectionTitle>
            <SectionTitleDesc $color="#121212">
              서울역 9번출구 바로 앞에 위치해 있습니다.
            </SectionTitleDesc>
          </SectionTitleContainer>
          <MapSection>
            <Map src={`${IMGBASE}/map.png`} alt="지도" />
            <MapNotice>
              <NoticeTitle>
                1층 로비 상연재 데스크에서
                <br />
                출입증을 수령하신 후 출입하실 수 있습니다.
              </NoticeTitle>
              <NoticeDesc>(출입증 미수령 시 출입이 제한됩니다.)</NoticeDesc>
            </MapNotice>
            <LocationContainer>
              <LocationWrapper>
                <Location>
                  <img src="/assets/images/icon/location-black.svg" alt="" />
                  서울 중구 한강대로 416, 서울스퀘어 4층 상연재
                </Location>
              </LocationWrapper>
              <Location>
                <Subway1>1</Subway1>
                서울역 9번 출구 도보 1분 (약 50m)
              </Location>
            </LocationContainer>
            <MapButtonWrapper>
              <MapButton
                onClick={() =>
                  window.open('https://naver.me/GlJIvLGv', '_blank')
                }
              >
                <img
                  src="/assets/images/promotion/seminar/naver.svg"
                  alt="naver"
                />
                네이버지도 보기
              </MapButton>
              <MapButton
                onClick={() =>
                  window.open(
                    'https://place.map.kakao.com/1315945138',
                    '_blank',
                  )
                }
              >
                <img
                  src="/assets/images/promotion/seminar/kakao.svg"
                  alt="kakao"
                />
                카카오맵 보기
              </MapButton>
            </MapButtonWrapper>
          </MapSection>
        </Section>

        <Section $bg="#fff" $padding={60} $gap={40}>
          <SectionTitle>자주 묻는 질문</SectionTitle>
          <Question questions={questionsData} />
        </Section>

        <Footer />
      </Container>
    </Component>
  );
}

export default Nplatform;

type SectionWrapperProps = {
  $padding?: number;
  $gap?: number;
  $bg?: string;
  $paddingBottom?: number;
};

type SectionTitleProp = {
  $color?: string;
  $size?: number;
  $weight?: number;
  $center?: boolean;
};

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
`;

const Container = styled.div`
  user-select: none;
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

const Header = styled.div`
  position: absolute;
  top: 0;

  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

const HeaderIconButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
`;

const Keyvisual = styled.div`
  width: 100%;
  background: #000;
  overflow: hidden;
  position: relative;
`;

const MainImg = styled.img`
  width: 100%;
  aspect-ratio: calc(360 / 720);
`;

const Section = styled.div<SectionWrapperProps>`
  display: flex;
  width: 100%;
  /* min-width: 360px; */
  padding: ${({ $padding, $paddingBottom }) =>
    $paddingBottom
      ? `${$padding}px 16px ${$paddingBottom}px`
      : `${$padding}px 16px`};
  background: ${({ $bg }) => $bg};
  flex-direction: column;
  align-items: center;
  gap: 40px;
  gap: ${({ $gap }) => `${$gap}px`};
`;

const SectionTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const SectionTitle = styled.div<SectionTitleProp>`
  color: ${({ $color }) => $color};
  text-align: center;
  font-family: Paperlogy;
  font-size: ${({ $size }) => ($size ? `${$size}px` : '24px')};
  font-style: normal;
  font-weight: ${({ $weight }) => ($weight ? $weight : 600)};
  line-height: 140%; /* 33.6px */
`;

const SectionTitleDesc = styled.div<SectionTitleProp>`
  color: ${({ $color }) => $color};
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 24px */
  letter-spacing: -0.3px;
`;

const CardContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const DifficultyCard = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #595963;
  background: #2a2c35;
`;

const DifficultyCardTitle = styled.div`
  color: #28feff;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 29px */
`;

const DifficultyCardDesc = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
`;

const ValueTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ValueCard = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #416368;
  background: #042b2e;
`;

const ValueCardTitle = styled.div`
  color: #28feff;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 29px */
`;

const ValueCardDesc = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%; /* 25.6px */
`;

const ValueCardCheckSection = styled.div`
  display: flex;
  padding-top: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
`;

const ValueCardCheckItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: #f2ffff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
`;

const CompetitionTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const CompetitionCard = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #416368;
  background: #042b2e;
`;

const CompetitionCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`;

const CompetitionCardNumber = styled.div`
  color: #8aa6a8;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 21.75px */
`;

const CompetitionCardTitle = styled.div`
  color: #28feff;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 29px */
`;

const CompetitionCardDesc = styled.div`
  color: #f2ffff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 25.6px */
  height: 81px;
  white-space: pre-line;
`;

const CompetitionCardImgContainer = styled.div`
  display: flex;
  height: 140px;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
`;

const CompetitionCardImg = styled.img`
  width: 140px;
  height: 140px;
`;

const ProcessSectionTitle = styled(SectionTitle)`
  background: linear-gradient(306deg, #fff 41.69%, #28feff 121.61%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const ProcessSectionDesc = styled.div`
  color: #28feff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const ApplicationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Bubble = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BubbleMessage = styled.div`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #e9fafa;
  color: #042b2e;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;

const BubbleTail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
    >
      <path d="M8 12L0 1.92809e-06L16 0L8 12Z" fill="#E9FAFA" />
    </svg>
  );
};

const ApplicationButton = styled.button`
  cursor: pointer;
  outline: none;
  border: none;

  display: flex;
  padding: 20px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #042b2e;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 28px */
  letter-spacing: -0.8px;
`;

const MapSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const Map = styled.img`
  width: 100%;
  aspect-ratio: 41/45;

  border-radius: 20px;
`;

const MapNotice = styled.div`
  display: flex;
  padding: 20px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #ecfdfd;
`;

const NoticeTitle = styled.div`
  color: #121212;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;

const NoticeDesc = styled.div`
  color: #1a7c83;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;

const LocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const LocationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #000;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
`;

const Subway1 = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  background: #263c96;

  color: #fff;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
`;

const MapButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MapButton = styled.div`
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 999px;
  border: 1px solid #e5e8ea;
  background: #1f1f1f;

  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  line-height: 145%;
  letter-spacing: -0.32px;

  & > img {
    border-radius: 4px;
    width: 16px;
    height: 16px;
    aspect-ratio: 1/1;
  }
`;

const BottomFloating = styled.div`
  position: fixed;
  z-index: 9999;
  left: 50%;
  transform: translateX(-50%);
  bottom: 24px;

  display: flex;
  width: calc(100% - 32px);
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 -2px 12px 0 rgba(24, 55, 70, 0.3);
`;

const FloatingContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const FloatingText = styled.div`
  color: #222;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const FloatingButton = styled.button`
  border: none;
  outline: none;

  display: flex;
  padding: 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  border-radius: 12px;
  background: #1a7c83;

  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const FloatingIcon = styled.img`
  width: 14px;
  height: 14px;
  aspect-ratio: 1/1;
`;

const CurveImg = styled.img`
  width: 100%;
  aspect-ratio: calc(1080px / 180px);
`;
